import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/oitFinal.fragment.js
var name, shader, oitFinalPixelShader;
var init_oitFinal_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/oitFinal.fragment.js"() {
    init_shaderStore();
    name = "oitFinalPixelShader";
    shader = `precision highp float;uniform sampler2D uFrontColor;uniform sampler2D uBackColor;void main() {ivec2 fragCoord=ivec2(gl_FragCoord.xy);vec4 frontColor=texelFetch(uFrontColor,fragCoord,0);vec4 backColor=texelFetch(uBackColor,fragCoord,0);float alphaMultiplier=1.0-frontColor.a;glFragColor=vec4(
frontColor.rgb+alphaMultiplier*backColor.rgb,
frontColor.a+backColor.a
);}`;
    ShaderStore.ShadersStore[name] = shader;
    oitFinalPixelShader = { name, shader };
  }
});

export {
  oitFinalPixelShader,
  init_oitFinal_fragment
};
